<template>
    <!--Package start-->
    <section class="theme-bg-gray " id="research">
        <div class="container" style="align-items: center;
        justify-content: center;
        margin-bottom: 30px;
        margin-top: 30px;
">
            <div class="row">
                <div class="col-md-12 text-center">
                    <div class="section-title">
                        <h2 class="text-green">กยท. ก้าวไกล พัฒนางานวิจัยและนวัตกรรมยาง</h2>
                        <img :src='"../assets/images/green-line.png"' alt="title-line" class="img-fluid">
                    </div>
                </div>
                <div class="col-md-12 text-center">
                   <carousel   v-bind:class='"news-slider"'
                    :margin=30
                    :loop=true
                    :items=1
                    :nav=false
                    :dots=true
                    :dotsEach=true
                    :autoplay=true
                    :responsive="{0:{items:1},768:{items:2},1024:{items:1},1200:{items:1}}"
          >

          <div class="item">
            <div class="row">
               <div class="col-md-3 col-sm-12 text-center">
               </div>
          <div class="col-md-6 col-sm-12 text-center">
           <div>
              
                <img src="../assets/images/org_1.jpeg" alt="news-1" class="img-fluid">
             
             
            </div>
          </div>
           <div class="col-md-3 col-sm-12 text-center">
               </div>
         
          </div>
           
          </div>

             <div class="item">
            <div class="row">
                 <div class="col-md-3 col-sm-12 text-center">
               </div>
          <div class="col-md-6 col-sm-12 text-center">
           <div>
              
                <img src="../assets/images/org_2.jpeg" alt="news-1" class="img-fluid">
             
             
            </div>
          </div>
            <div class="col-md-3 col-sm-12 text-center">
               </div>
          </div>
           
          </div>

             <div class="item">
            <div class="row">
                 <div class="col-md-3 col-sm-12 text-center">
               </div>
          <div class="col-md-6 col-sm-12 text-center">
           <div>
              
                <img src="../assets/images/org_3.jpeg" alt="news-1" class="img-fluid">
             
             
            </div>
          </div>
             <div class="col-md-3 col-sm-12 text-center">
               </div>
          </div>
           
          </div>


             <div class="item">
            <div class="row">
                 <div class="col-md-3 col-sm-12 text-center">
               </div>
          <div class="col-md-6 col-sm-12 text-center">
           <div>
              
                <img src="../assets/images/org_4.jpeg" alt="news-1" class="img-fluid">
             
             
            </div>
          </div>
             <div class="col-md-3 col-sm-12 text-center">
               </div>
         
          </div>
           
          </div>




         <div class="item">
            <div class="row">
          <div class="col-md-6 col-sm-12 text-center">
           <div>
              <a href="http://www.raot.co.th/download/research_report_62.pdf" target="_blank">
                <img src="../assets/images/research_1.jpg" alt="news-1" class="img-fluid">
              </a>
             
            </div>
          </div>
          <div class="col-md-6 col-sm-12" style="text-align:left">
        <div class="section-title pt-5">
                        <!-- <h2 class="text-white">เอกสารดาวน์โหลด</h2>
                        <img :src='"../assets/images/white-line.png"' alt="title-line" class="img-fluid"> -->
                        <b-card header="รายงานผลวิจัยเรื่องเต็ม" class="text-center">
        <div class="blog-cat-detail text-left">
                 <ul>
                   <li  class="marg-15">
                     <a href="http://www.raot.co.th/download/research_report_62.pdf" target="_blank">
                       <i class="fa fa-angle-right" aria-hidden="true"></i>รายงานผลวิจัยเรื่องเต็ม
                    </a>
                   </li>
                  
                   
                 </ul>
               </div>
      </b-card>
                    </div>   </div>
          </div>
           
          </div>
         <div class="item">
            <div class="row">
          <div class="col-md-6 col-sm-12 text-center">
           <div>
              <a href="http://www.raot.co.th/download/research_report_61.pdf" target="_blank">
                <img src="../assets/images/research_2.jpg" alt="news-1" class="img-fluid">
              </a>
             
            </div>
          </div>
          <div class="col-md-6 col-sm-12" style="text-align:left">
        <div class="section-title pt-5">
                        <!-- <h2 class="text-white">เอกสารดาวน์โหลด</h2>
                        <img :src='"../assets/images/white-line.png"' alt="title-line" class="img-fluid"> -->
                        <b-card header="รายงานผลวิจัยสิ้นสุด ประจำปี 2561" class="text-center">
        <div class="blog-cat-detail text-left">
                 <ul>
                   <li  class="marg-15">
                     <a href="http://www.raot.co.th/download/research_report_61.pdf" target="_blank">
                       <i class="fa fa-angle-right" aria-hidden="true"></i>รายงานผลวิจัยสิ้นสุด ประจำปี 2561
                    </a>
                   </li>
                
                   
                 </ul>
               </div>
      </b-card>
                    </div> 

 </div>
          </div>
           
          </div>
         <div class="item">
            <div class="row">
          <div class="col-md-6 col-sm-12 text-center">
           <div>
            
                <img src="../assets/images/research_3.jpg" alt="news-1" class="img-fluid">
            
             
            </div>
          </div>
          <div class="col-md-6 col-sm-12" style="text-align:left">
      <div class="section-title pt-5">
                        <!-- <h2 class="text-white">เอกสารดาวน์โหลด</h2>
                        <img :src='"../assets/images/white-line.png"' alt="title-line" class="img-fluid"> -->
                        <b-card header="วารสารยางพารา" class="text-center">
        <div class="blog-cat-detail text-left">
                 <ul>
                   <li  class="marg-15">
                     <a href="http://www.raot.co.th/ebook/ebook-44.pdf" target="_blank">
                       <i class="fa fa-angle-right" aria-hidden="true"></i>ดาวน์โหลด วารสารยางพารา ปีที่ 44
                    </a>
                   <li  class="marg-15">
                     <a href="http://www.raot.co.th/ebook/ebook-43.pdf" target="_blank">
                       <i class="fa fa-angle-right" aria-hidden="true"></i>ดาวน์โหลด วารสารยางพารา ปีที่ 43
                    </a>
                   </li>
                    <li  class="marg-15">
                     <a href="http://www.raot.co.th/ebook/ebook-42.pdf" target="_blank">
                       <i class="fa fa-angle-right" aria-hidden="true"></i>ดาวน์โหลด วารสารยางพารา ปีที่ 42
                    </a>
                   </li>
                    <li  class="marg-15">
                     <a href="http://www.raot.co.th/ebook/ebook-41.pdf" target="_blank">
                       <i class="fa fa-angle-right" aria-hidden="true"></i>ดาวน์โหลด วารสารยางพารา ปีที่ 41
                    </a>
                   </li>
                   
                 </ul>
               </div>
      </b-card>
                    </div>
           </div>
          </div>
           
          </div>

           <div class="item">
            <div class="row">
          <div class="col-md-6 col-sm-12 text-center">
           <div>
             
                <img src="../assets/images/research_4.jpg" alt="news-1" class="img-fluid">
           
             
            </div>
          </div>
          <div class="col-md-6 col-sm-12" style="text-align:left">
      <div class="section-title pt-5">
                        <!-- <h2 class="text-white">เอกสารดาวน์โหลด</h2>
                        <img :src='"../assets/images/white-line.png"' alt="title-line" class="img-fluid"> -->
                        <b-card header="พัฒนาองค์ความรู้ด้านยางพารา" class="text-center">
        <div class="blog-cat-detail text-left">
                 <ul>
                    <li  class="marg-15">
                     <a href="https://drive.google.com/file/d/1UXWXc5Q9Pgjfwd4M78ZP24LQR0qXGuxv/view" target="_blank">
                       <i class="fa fa-angle-right" aria-hidden="true"></i>ระบบการสร้างสวนยางแบบผสมผสานฯ
                    </a>
                   </li>
                    <li  class="marg-15">
                     <a href="https://drive.google.com/file/d/1X8hllROk2KsedJN5vKG0YYJe715Dd953/view" target="_blank">
                       <i class="fa fa-angle-right" aria-hidden="true"></i>หลักการสร้างสวนยาแบบผสมผสาน
                    </a>
                   </li>
                    <li  class="marg-15">
                     <a href="https://drive.google.com/file/d/1Val1NThTZG2t-OyeBsMBSmORfYm5hjox/view" target="_blank">
                       <i class="fa fa-angle-right" aria-hidden="true"></i>การปฏิบัติทางการเกษตรที่ดีสำหรับยางพารา
                    </a>
                   </li>
                    <li  class="marg-15">
                     <a href="http://www.raot.co.th/download/pdf/5.km_research_new-leaves-diseas.pdf" target="_blank">
                       <i class="fa fa-angle-right" aria-hidden="true"></i>โรคใบร่วงชนิดใหม่ในยางพารา

                    </a>
                   </li>
                    <li  class="marg-15">
                     <a href="http://www.raot.co.th/download/rubber_research/collect_soil_sample.pdf" target="_blank">
                       <i class="fa fa-angle-right" aria-hidden="true"></i>การเก็บตัวอย่างดินในสวนยาง
                    </a>
                   </li>
                    <li  class="marg-15">
                     <a href="http://www.raot.co.th/download/rubber_research/extra_income.pdf" target="_blank">
                       <i class="fa fa-angle-right" aria-hidden="true"></i>การเสริมรายได้ในสวนยาง
                    </a>
                   </li>
                 </ul>
               </div>
      </b-card>
                    </div>
           </div>
          </div>
           
          </div>


           <div class="item">
            <div class="row">
          <div class="col-md-6 col-sm-12 text-center">
           <div>
             <router-link :to="{ name: 'Blogdetails' }" >
                <img src="../assets/images/research_5.jpg" alt="news-1" class="img-fluid">
             </router-link>
             
            </div>
          </div>
          <div class="col-md-6 col-sm-12" style="text-align:left">
      <div class="section-title pt-5">
                        <!-- <h2 class="text-white">เอกสารดาวน์โหลด</h2>
                        <img :src='"../assets/images/white-line.png"' alt="title-line" class="img-fluid"> -->
                        <b-card header="พัฒนางานด้านวิชาการ" class="text-center">
        <div class="blog-cat-detail text-left">
                 <ul>
                   <li  class="marg-15">
                     <a href="http://www.raot.co.th/download/technical_data_of_rubber_61.pdf" target="_blank">
                       <i class="fa fa-angle-right" aria-hidden="true"></i>ข้อมูลวิชาการยางพาราปี 61

                    </a>
                   </li>
                     <li  class="marg-15">
                     <a href="http://www.raot.co.th/download/pdf/research_abstract_57-61.pdf" target="_blank">
                       <i class="fa fa-angle-right" aria-hidden="true"></i>รวมบทคัดย่องานวิจัยปี 57-61

                    </a>
                   </li>
                     <li  class="marg-15">
                     <a href="http://www.raot.co.th/download/pdf/instruction_rubber_type2554.pdf" target="_blank">
                       <i class="fa fa-angle-right" aria-hidden="true"></i>คำแนะนำพันธ์ยางปี 2554

                    </a>
                   </li>
                    <li  class="marg-15">
                     <a href="http://www.raot.co.th/download/pdf/instruction_rubber_type2559.pdf" target="_blank">
                       <i class="fa fa-angle-right" aria-hidden="true"></i>คำแนะนำพันธ์ยางปี 2559
                    </a>
                   </li>
                   
                 </ul>
               </div>
      </b-card>
                    </div>
           </div>
          </div>
           
          </div>


           <div class="item">
            <div class="row">
          <div class="col-md-6 col-sm-12 text-center">
           <div>
             <router-link :to="{ name: 'Blogdetails' }" >
                <img src="../assets/images/research_6.jpg" alt="news-1" class="img-fluid">
             </router-link>
             
            </div>
          </div>
          <div class="col-md-6 col-sm-12" style="text-align:left">
      <div class="section-title pt-5">
                        <!-- <h2 class="text-white">เอกสารดาวน์โหลด</h2>
                        <img :src='"../assets/images/white-line.png"' alt="title-line" class="img-fluid"> -->
                        <b-card header="หุ่นจำลองเด็กปากแหว่งเพดานโหว่" class="text-center">
        <div class="blog-cat-detail text-left">
                <p>
                  	ใช้เป็นสื่อการสอนเพื่อส่งเสริมความรอบรู้ด้านสุขภาพให้แก่บุคลากรสาธารณสุขและผู้ปกครอง สำหรับดูแลสุขภาพเด็กปากแหว่งเพดานโหว่ ผลิตจากน้ำยางธรรมชาติ 100% 
	

                </p>
                  <p>
	<b>วิธีการผลิต :</b> ใช้การตีฟองด้วยโครงสร้างของยางธรรมชาติที่มีความยืดหยุ่นสูง ความนุ่มของฟองยางมีความใกล้เคียงกับผิวของมนุษย์ ช่วยในการสัมผัสให้เกิดทักษะความจำให้ถูกต้องมากยิ่งขึ้นในการนำความรู้เข้าใจไปปฏิบัติได้จริง


                </p>
                  <p>
 <b>	ปริมาณการใช้ยาง :</b> ผลิตจากน้ำยางข้น 60% คิดเป็นน้ำหนักยางแห้ง 1,200 กรัม/ชิ้น

                </p>
               </div>
      </b-card>
                    </div>
           </div>
          </div>
           
          </div>


           <div class="item">
            <div class="row">
          <div class="col-md-6 col-sm-12 text-center">
           <div>
             <router-link :to="{ name: 'Blogdetails' }" >
                <img src="../assets/images/research_7.jpg" alt="news-1" class="img-fluid">
             </router-link>
             
            </div>
          </div>
          <div class="col-md-6 col-sm-12" style="text-align:left">
      <div class="section-title pt-5">
                        <!-- <h2 class="text-white">เอกสารดาวน์โหลด</h2>
                        <img :src='"../assets/images/white-line.png"' alt="title-line" class="img-fluid"> -->
                        <b-card header="แผ่นรองเท้าสำหรับผู้ป่วยโรครองช้ำและโรคเท้าแบน (Insour rubber)" class="text-center">
        <div class="blog-cat-detail text-left">
                  <p>
               	ผลิตจากยางพาราธรรมชาติแท้ 100% ด้วยเทคนิคการตีฟองจากคุณสมบัติของยางธรรมชาติที่มีความยืดหยุ่น ปรับให้มีความนุ่มและน้ำหนักเบา จึงเหมาะสำหรับใช้เป็นแผ่นรองใส่ในรองเท้าเพื่อป้องกันโรครองช้ำสำหรับผู้ที่ต้องยืนและเดินเป็นเวลานานๆ 

                </p>
                  <p>
		สามารถใช้รักษาผู้ป่วยและบรรเทาอาการปวดเท้าเนื่องจากอาการรองช้ำ และเท้าแบน  เหมาะสำหรับทหาร พยาบาล ผู้สูงอายุ และบุคคลทั่วไป นอกจากนี้ ยังช่วยรักษาสิ่งแวดล้อมและทดแทนการนำเข้าของวัสดุสังเคราะห์ ใช้เป็นอุปกรณ์ทางการแพทย์ได้  
	

                </p>
                  <p>
 <b>	ปริมาณการใช้ยาง :</b>  ผลิตจากน้ำยางข้น 60% คิดเป็นน้ำหนักยางแห้ง 196 กรัม/แผ่น

                </p>
               </div>
      </b-card>
                    </div>
           </div>
          </div>
           
          </div>

          

          </carousel>
                    </div>
                </div>
            </div>
       
    </section>
    <!--Package end -->
</template>
<script>
export default {
  name: 'Package'
}
</script>
